import ClickOutside from './directives/click-outside';

export default class Default {
  constructor(main) {
    Vue.directive('click-outside', ClickOutside);
  }
}